import * as types from './types';
// eslint-disable-next-line import/no-cycle
import fetch from '../../lib/fetch';
import Vue from 'vue';
import {
  getParseMaterialInfo,
  transformPrice,
  transformCommisionRate,
} from '../../lib/helper';
import {
  errCodeMap,
} from '../../lib/errors';
import { sassType, getMedia } from '@/lib/enum';
import { get } from 'lodash';
import { uuid } from '@/lib/uuid';

// 搜索商品时生成唯一的UUID，便于后台搜索推荐
// 同一条件搜索，翻页时认为是同一个搜索行为，其他情况视为不同搜索行为（即连续点击2次搜索，均认为不同的搜索行为）
let lastSearchUUID = uuid();
const getSearchUUID = function (currentPage = 1) {
  if (currentPage !== 1) {
    // 翻页
    return lastSearchUUID;
  }

  lastSearchUUID = uuid();
  return lastSearchUUID;
};

const filterInitial = {
  status: '',
  title: '',
  pid: '',
  price: '',
  source: '',
  categoryID: undefined,
  categoryName: '全部类别',
  orderBy: '',
  commission: '',
  commissionRate: '',
  commodityPromotion: [], // 商品促销复选框
  discountPercentScope: 1, // 商品促销API字段；1，全量（默认）；2，有商品促销；3，无商品促销
  loading: false,
  activeTab: '',
  channel: '', // 推荐专题搜索条件，枚举值：高佣 higher_commission、所有 all_subject、畅销 best_selling、9块9 nine_yuan_nine、节日 special_holiday
};

export default {
  namespaced: true,
  state: {
    hotProductList: [],
    hotPriCateList: [],
    pageInfo: {
      page: 1,
      count: 32,
      total: 0,
    },
    media_type: '',
    media_id: '',
    uid: '',
    filter: {
      ...filterInitial,
    },
    hotTabList: [],
    goodPoolTabList: [],
    activeTabEqualGoodPool: false,
    showfilter: true,
    shoppingGuild: [],
    loading: false,
    nomore: false,
    hasOm: false,
    dafaultActiveTab: '',
    XeppShopID: [],
  },

  getters: {
    // 根据栏目TAB类型判断是否加载全部商品（例：全部商品、每日活动）
    isLoadAllData: (state) => {
      const { activeTab } = state.filter;
      if (activeTab !== '') {
        const activeTabConfig = state.goodPoolTabList.find(item => item.id === activeTab) || null;

        if (activeTabConfig !== null) {
          return activeTabConfig.type === 1;  // type, 枚举值 1、0；1 走 search 接口，0走 get_inner_pool_product_list 接口
        }
      }

      return true;
    },
  },

  mutations: {
    //  设置全部商品企鹅号小店列表展示
    [types.SET_HAS_OM](state, status) {
      state.hasOm = status;
    },
    [types.SET_XEPP_SHOPID](state, { id }) {
      state.XeppShopID = id;
    },
    resetShoppingGuild(state) {
      state.shoppingGuild = [];
    },
    [types.SET_SHOPPING_GUILD](state, list) {
      state.shoppingGuild = list;
    },
    [types.SET_HOT_PRIMARY_CATELIST](state, list) {
      state.hotPriCateList = list;
    },
    [types.SET_HOT_PRODUCT_LIST](state, {
      paginfo,
      products,
    }) {
      state.hotProductList = products;
      const pageInfo = paginfo || {}; // 接口 paginfo 字段会存在为null的情况，此处作为兼容处理
      state.pageInfo.total = pageInfo.total || 0;
    },
    [types.SET_TOTAL](state, { total }) {
      state.pageInfo.total = total;
    },
    [types.RESET_HOT_PRODUCT_LIST](state) {
      state.hotProductList = [];
    },
    [types.SET_HOT_PRODUCT_FILTER](state, filter) {
      state.filter = {
        ...state.filter,
        ...filter,
      };

      if (state.filter && state.filter.activeTab) {
        const tab = state.goodPoolTabList.find(item => item.id === state.filter.activeTab);
        state.activeTabEqualGoodPool = !!tab;
        state.showfilter = !(tab && tab.select_state === 1);
      }
    },
    [types.SET_HOT_MEDIA_INFO](state, {
      mediaType,
      mediaId,
      uid,
    }) {
      state.media_id = mediaId;
      state.media_type = mediaType;
      state.uid = uid;
    },
    [types.SET_HOT_PRODUCT_LIST_PAGE_NUM](state, {
      pageNum,
    }) {
      state.pageInfo.page = pageNum;
    },
    [types.SET_HOT_PRODUCT_LIST_PAGE_COUNT](state, {
      pageCount,
    }) {
      state.pageInfo.count = pageCount;
    },
    [types.RESET_HOT_PRODUCT_FILTER](state, payload = {}) {
      const initial = filterInitial;
      initial.activeTab = state.filter.activeTab;
      state.filter = {
        ...initial,
        ...payload,
      };
    },
    [types.SET_HOT_TAB_LIST](state, {
      list,
    }) {
      state.hotTabList = list.filter(item => item.key !== 'ams');
    },
    [types.SET_GOOD_POOL_TAB_LIST](state, { list }) {
      state.goodPoolTabList = list;
      const goodPoolTabList = state.goodPoolTabList.map(item => ({
        display_name: item.short_name,
        key: item.id,
        type: item.type,
      }));

      if (goodPoolTabList.length === 0) {
        return;
      }

      // 设置默认tab
      const { activeTab } = state.filter;
      if (activeTab === '') {
        const defaultTabConfig = goodPoolTabList.find(item => item.display_name.includes('全部商品')) || null;
        state.dafaultActiveTab = defaultTabConfig ? defaultTabConfig.key : goodPoolTabList[0].key;
        state.filter.activeTab = state.dafaultActiveTab;
      }
    },
    [types.SET_NO_MORE](state, { nomore }) {
      state.nomore = nomore;
    },
    [types.SET_LOADING](state, { loading }) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchShopingGuild({
      commit,
      state,
    }, {
      tabId,
    }) {
      let columnId = '';
      if (tabId === 'om') {
        columnId = '143';
      } else {
        columnId = tabId === 'default' ? -1 : tabId;
      }
      const req = {
        topic_name: '',
        media_type: getMedia(state.media_type).type,
        state: 0,
        column_id: columnId,
        page: {
          limit: 100,
          offset: 0,
        },
      };
      const res = await fetch.post('v1/pcgec/product_pool/get_shopping_guide_topic', {
        ...req,
      });

      if (res.code === 0) {
        const list = res.topics.filter(item => item.state === 1);
        commit(types.SET_SHOPPING_GUILD, list);

        return true;
      }

      return false;
    },
    async fetchHotProducts({
      commit,
      state,
      dispatch,
      getters,
    }) {
      commit(types.SET_TOTAL, { total: 0 });

      if (state.nomore && state.pageInfo.page > 1) return false;

      if (!getters.isLoadAllData) {
        const fetchGoodPoolResult = await dispatch('fetchGoodPool', { title: '' });
        return fetchGoodPoolResult;
      }

      if (state.loading) return false;

      commit(types.SET_LOADING, { loading: true });
      const data = {
        method: 'post',
        body: {
          key: 'default',
          biz_name: 'eshop',
          title: state.filter.title,
          pid: state.filter.pid,
          price: transformPrice(state.filter.price),
          source: state.filter.source,
          cat_id: Number(state.filter.categoryID) || undefined,
          media_type: state.media_type,
          media_id: state.media_id,
          uid: state.uid,
          status: state.filter.status,
          order_by: state.filter.orderBy.trim(),
          page: state.pageInfo.page,
          count: state.pageInfo.count,
          commission_rate: transformCommisionRate(state.filter.commissionRate),
          commission: transformPrice(state.filter.commission),
          shop_id_list: state.XeppShopID,
          discount_percent_scope: state.filter.discountPercentScope,
          biz_channel: state.filter.channel,
          search_session_id: getSearchUUID(state.pageInfo.page),
          is_om: state.filter.activeTab === 'om',
        },
      };

      const res = await fetch.post('v1/product/search', {
        ...data.body,
      });
      commit(types.SET_LOADING, { loading: false });

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '获取精选商品列表失败');
        return false;
      }

      const list = get(res, 'result.products') || [];

      res.result.products = list.map(item => ({
        ...item,
        material_info: getParseMaterialInfo(item.material_info),
      }));

      if (state.pageInfo.page > 1 && res.result.products.length === 0) {
        commit(types.SET_NO_MORE, { nomore: true });
        return true;
      }

      commit(types.SET_HOT_PRODUCT_LIST, res.result);

      return true;
    },
    async fetchHotPriCateList({
      commit,
    }) {
      const res = await fetch.post('v1/product/hotprimcates', {});

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '获取精选商品类目失败');

        return;
      }

      commit(types.SET_HOT_PRIMARY_CATELIST, res.data);
    },
    async fetchHotTab({
      commit,
    }, {
      mediaType,
    }) {
      const data = {
        method: 'post',
        body: {
          media_type: mediaType,
        },
      };
      const res = await fetch.post('v1/product/hot_tab', {
        ...data.body,
      });

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '获取精选Tab信息失败');

        return;
      }

      commit(types.SET_HOT_TAB_LIST, {
        list: res.result,
      });
    },
    async fetchGoodPoolTabList({ commit }, { mediaType }) {
      const media = getMedia(mediaType);

      const res = await fetch.post('v1/pcgec/product_pool/get_media_selected_column_list', {
        media_type: media.type,
        page: {
          limit: 100,
          offset: 0,
        },
        state: 1,
      });

      if (res.code !== 0) {
        const errMsg = res.msg ? `获取Tab配置失败：${res.msg}` : '获取Tab配置失败';
        Vue.prototype.$tip.error(errMsg);
        return false;
      }

      commit(types.SET_GOOD_POOL_TAB_LIST, { list: res.columns });

      return true;
    },

    // 搜索其他栏目的商品数据（非全部商品栏目，或者专题栏目的数据）
    async fetchGoodPool({ commit, state }) {
      // 查找当前TAB的配置
      const current = state.goodPoolTabList.find(item => item.id === state.filter.activeTab);
      if (current === undefined) return false;

      // 获取当前TAB商品池ID数组，例 [168, 272]
      const poolIds = current.pool_item.map(item => Number(item.id));
      if (!poolIds.length) return false;

      const { page, count } = state.pageInfo;
      const { orderBy } = state.filter;
      const params = {
        page: {
          offset: count * (page - 1),
          limit: count,
        },
        cond: {
          title: state.filter.title,
          orderInfo: orderBy.replace(' ', ','),
          commissionInfo: transformPrice(state.filter.commission),
          priceInfo: transformPrice(state.filter.price),
          commissionRateInfo: transformCommisionRate(state.filter.commissionRate),
          priSort: state.filter.categoryName === '全部类别' ? '' : state.filter.categoryName,
          saasTypeStr: state.filter.source,
          discount_percent_scope: state.filter.discountPercentScope,
          media_type: state.media_type,
          media_id: state.media_id,
        },
        poolIds,
      };

      if (state.loading) {
        return false;
      }

      commit(types.SET_LOADING, { loading: true });
      const res = await fetch.post('v1/pcgec/product_pool/get_inner_pool_product_list', params);
      commit(types.SET_LOADING, { loading: false });

      if (res.code !== 0) {
        const errMsg = res.msg ? `商品列表加载失败：${res.msg}` : '商品列表加载失败';
        Vue.prototype.$tip.error(errMsg);
        return false;
      }

      const product = res.product_list.map(item => ({
        create_time: item.create_time,
        import_type: item.import_type,
        ...item.media_product_info,
        saas_type_cn: sassType[item.media_product_info.saas_type] || '未知',
      }));

      if (state.pageInfo.page > 1 && product.length === 0) {
        commit(types.SET_NO_MORE, { nomore: true });
        return true;
      }

      commit(types.SET_HOT_PRODUCT_LIST, { products: product, paginfo: { total: Number(res.total) } });
      return true;
    },
  },
};
